const FORMULATE_ERROR_MESSAGE = {
  required: 'FORMULATE.ERROR.REQUIRED',
};

export { FORMULATE_ERROR_MESSAGE };
